module.exports = __webpack_public_path__ + "img/treasury_02.ece7a0e4.png";